export interface TableLayout {
  id: string;
  organizationId: string;
  name?: string | null;
  number: number;
  positionX: number;
  positionY: number;
  width: number;
  height: number;
  tabsIds: string[];
  roomId: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export const getTableDisplayName = (
  table: Pick<TableLayout, 'name' | 'number'>
): string => {
  const trimmed = table.name?.trim();
  return trimmed ? trimmed : String(table.number);
};
